import { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import ListIndustries from "../../components/industries/list-industries/ListIndustries";
import axios from "axios";
import { Loaders } from "../Loaders";

function ListIndustriesPage() {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const ListIndustriesData = async () => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/industry?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res.data);
      setLoader(false)
    } catch (error) {
      setLoader(false)
      alert("list industries data not found");
    }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/industry?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { setLoader(false) }
  }

  useEffect(() => {
    ListIndustriesData(1);
  }, []);

  const onChangeVal = (e) => {
    // console.log(e);
    ListIndustriesData(e)

  };

  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title="Industries" />
        <h3 className="page-title">
          Manage Industries
        </h3>
        <ListIndustries data={data} ListIndustriesData={ListIndustriesData} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
}
export default ListIndustriesPage;
